export default __webpack_public_path__ + "static/media/Eye_5_F_C1.f52b76e8.svg";